import type { GuideTourId } from '../content/tours';

/**
 * Panel tour for a route. The wizard is absent on purpose: its steps all share
 * `/crear-torneo/:stepPath`, so those tours are started by step id from
 * WizardContainer, not resolved from the URL.
 */
const ROUTE_TO_TOUR: Record<string, GuideTourId> = {
  '/inicio': 'panel.inicio',
  '/clubs': 'panel.clubs',
  // The tournament list lives at "/" (Home), which is what the sidebar's "Mis
  // Torneos" links to. "/tournaments" renders an empty placeholder page.
  '/': 'panel.tournaments',
  '/cuenta-corriente': 'panel.current-account',
  '/profile': 'panel.profile',
};

export function resolveTourForRoute(pathname: string): GuideTourId | null {
  return ROUTE_TO_TOUR[pathname] ?? null;
}
